



































import { Component, Prop, Vue } from 'vue-property-decorator';
import BarChart from '../chartjs/BarChart.vue';
import LoadingSpinner from '@/shared/components/loadingSpinner/LoadingSpinner.vue';
import ChartError from '../ChartError.vue';
import ChartLabels from '../ChartLabels.vue';
import FlowIcon from 'vue-material-design-icons/Waves.vue';
import ChartNoData from '@/features/reports/components/ChartNoData.vue';
import HelpIcon from 'vue-material-design-icons/HelpCircleOutline.vue';
import { Data, Series, SeriesConfig } from '../../models';
import shortid from 'shortid';

@Component({
	components: {
		BarChart,
		LoadingSpinner,
		ChartError,
		ChartNoData,
		ChartLabels,
		FlowIcon,
		HelpIcon
	},
})
export default class BillableConversationsTrendChart extends Vue {
	@Prop() public data!: Data;

	@Prop() public loadedData!: boolean;

	@Prop() public loadingError!: boolean;

	public reportId = '';

	public tooltipText = 'A billable conversation is classified as a contact who has sent at least one message in the month. If the contact has sent/received more than 20 messages in a month, each additional set of up to 20 messages is counted as another billable conversation.';

	public created() {
		this.reportId = `${shortid.generate()}`;
	}

	public get seriesOrder(): SeriesConfig[] {
		return [
			{ name: 'Conversations', displayName: 'Billable Conversations' }
		];
	}

	public get reportData(): Data {
		return {
			scale: this.data.scale,
			series: this.seriesOrder.map(seriesConfig => {
				return this.data.series.find(s => s.name === seriesConfig.name)
					|| this.createBlankSeries(seriesConfig.name, seriesConfig.displayName);
			})
		};
	}

	public createBlankSeries(name: string, displayName: string): Series {
		return {
			name,
			displayName: displayName || name,
			data: this.data.scale.labels.map(() => 0)
		};
	}

	public get loadedAndNotReturnedData() {
		return this.loadedData && (!this.data || !this.data.series || this.data.series.length === 0);
	}

	public get loadedAndReturnedData() {
		return this.loadedData && this.data && this.data.series && this.data.series.length > 0;
	}
}
